export default "__VITE_ASSET__BhU4txM0__"